import {postObjectWithApiError, IResultAndError} from '../../lib/ChoiceApi'; 
import {IWhaicReportInput,IWhaicReportingResponse} from '../../lib/Models/Whaic837ReportModel'; 

export enum ErrorReturnMessage {
    reportDisplay = "Unable to get Reporting Data"
};

export async function getWhaicReport(payload: IWhaicReportInput): Promise<IResultAndError<IWhaicReportingResponse>>{
    return postObjectWithApiError("api/Billing/Whaic/GetWhaicReport", payload);
};

